module.exports = __webpack_public_path__ + "static/img/dimitry-anikin-uwP28TaFTr4-unsplash_thumb.dd68e44.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/ads/standard_bg/dimitry-anikin-uwP28TaFTr4-unsplash_thumb.png
// module id = 9D2/
// module chunks = 4